// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"8689efd1","207":"a0eb6fbc","254":"9fce0cd1","286":"11c52a93","413":"c73fce01","507":"12f53269","753":"45366c1d","756":"32bf43a3","849":"e41e90c4","909":"40027b23","925":"5e65add1","972":"6ab1984a"}[chunkId] + ".chunk.js";
};